import { isNotUndefined } from "./typescriptUtils";
/**
 * Use this method when getting all values from a web-api map type.
 * To be type safe, they're `Partial<Record<string, Foo>>`, which causes
 * Object.values(theMap) to be Array<Foo | undefined>.
 */ export var mapValues = function(partial) {
    if (!partial) {
        return [];
    }
    return Object.values(partial).filter(isNotUndefined);
};
